export default __webpack_public_path__ + "static/media/naac-logo.8c6fe5e1.png";